import(/* webpackMode: "eager", webpackExports: ["AppClientWrapper"] */ "/app/apps/static-pages/src/components/app-client-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@quantum-wealth/dionysus-ui/dist/styles.css");
;
import(/* webpackMode: "eager" */ "/app/apps/static-pages/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-notifications-component/dist/theme.css");
;
import(/* webpackMode: "eager" */ "/app/packages/alpheya-common/src/container/dynamic-translation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderingTime"] */ "/app/packages/alpheya-common/src/container/rendering-time.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/packages/alpheya-common/src/container/theme-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/alpheya-common/src/i18n/i18n-provider.tsx");
